export const AVA_DOMAIN = 'ava.me';
export const AVA_URL = `https://www.${AVA_DOMAIN}`;
